import withProps from '../../utils/withProps';
import ComponentEditor from './editor';

export default withProps(ComponentEditor, {
    isNew: true,
    level: '',
    skill: '',
    componentId: ''
});